/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsLastRewardEventFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsLastRewardEventFormat = ClosedEnum<
  typeof GetApiV3MetricsLastRewardEventFormat
>;

export type GetApiV3MetricsLastRewardEventRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsLastRewardEventFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsLastRewardEventFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsLastRewardEventFormat> = z.nativeEnum(
    GetApiV3MetricsLastRewardEventFormat,
  );

/** @internal */
export const GetApiV3MetricsLastRewardEventFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsLastRewardEventFormat> =
    GetApiV3MetricsLastRewardEventFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsLastRewardEventFormat$ {
  /** @deprecated use `GetApiV3MetricsLastRewardEventFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsLastRewardEventFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsLastRewardEventFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsLastRewardEventFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsLastRewardEventRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsLastRewardEventRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsLastRewardEventFormat$inboundSchema.default("json"),
  start: z.nullable(z.number()).default(null),
  step: z.number().default(7200),
});

/** @internal */
export type GetApiV3MetricsLastRewardEventRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsLastRewardEventRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsLastRewardEventRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsLastRewardEventRequest
> = z.object({
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsLastRewardEventFormat$outboundSchema.default("json"),
  start: z.nullable(z.number()).default(null),
  step: z.number().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsLastRewardEventRequest$ {
  /** @deprecated use `GetApiV3MetricsLastRewardEventRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsLastRewardEventRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsLastRewardEventRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsLastRewardEventRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsLastRewardEventRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsLastRewardEventRequest$Outbound;
}

export function getApiV3MetricsLastRewardEventRequestToJSON(
  getApiV3MetricsLastRewardEventRequest: GetApiV3MetricsLastRewardEventRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsLastRewardEventRequest$outboundSchema.parse(
      getApiV3MetricsLastRewardEventRequest,
    ),
  );
}

export function getApiV3MetricsLastRewardEventRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsLastRewardEventRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsLastRewardEventRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsLastRewardEventRequest' from JSON`,
  );
}
